<app-navigation/>

<div class="container-fluid">
    <div class="row">
        <router-outlet/>
    </div>
</div>
